<template>
  <div v-if="products?.length" class="flex justify-between items-center mb-3">
    <slot name="title"/>
  </div>
  <template v-if="products?.length">
    <product-slider :products="products" :source-data="sourceData"/>
  </template>
</template>

<script setup>
import productSlider from "@/components/home/product-slider/index";
import {useCustomFetch} from "@/composables/useFetch";

const props = defineProps({
  data: {
    type: Object,
    default: () => {
    }
  },
  sourceData: {
    type: Object,
    default: {}
  }
})

const {category, productId} = props.data
const {data: response} = await useCustomFetch('?route=rest/product_admin/getProductSection1Content', {
  category,
  product_id: productId
})
const products = computed(() => response.value?.products || [])
</script>